import { gql } from "@apollo/client";

export const CREATE_INDICACION = gql`
    mutation CreateIndicacionRI(
        $idDatosGeneralesRI: Int!
        $idInsumo: Int!
        $idPantallaRI: Int!
        $idComboRIValorViaAdministracion: Int
        $idComboRIValorUnidadtiempo: Int
        $idComboRIValorIntervalo: Int
        $cantidadDiaria: Decimal
        $idComboRIValorUnidadDosis: Int
    )
    {
        createIndicacionRI(
            input: {
                idDatosGeneralesRI: $idDatosGeneralesRI
                idInsumo: $idInsumo
                idPantallaRI: $idPantallaRI
                idComboRIValorViaAdministracion: $idComboRIValorViaAdministracion
                idComboRIValorUnidadtiempo: $idComboRIValorUnidadtiempo
                idComboRIValorIntervalo: $idComboRIValorIntervalo
                cantidadDiaria: $cantidadDiaria
                idComboRIValorUnidadDosis: $idComboRIValorUnidadDosis
            }
        ){
            idIndicacionRI
        }
    }
`;